<template>
  <div>
    <div id="flower-1" class="top-left">
      <img src="../assets/flower_1.png" alt="flower 1" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Left',
  data () {
    return {
      msg: ''
    }
  }
}

</script>

<style lang="scss">

%fixed-auto {
  position: fixed;
  z-index: -1;
  width: auto;
  height: auto;
  opacity: 0.5;
}

%top70 {
  top: 70px;
}

%left0 {
  left: 0;
}

.top-left {
 @extend %fixed-auto;
 @extend %top70;
 @extend %left0;
}

</style>



// WEBPACK FOOTER //
// src/components/Left.vue